import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';

const Price = (_param)=>{
    var { value , centAmount =true , currency , className , type ='default' , size ='custom' , 'aria-label': ariaLabel  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "value",
        "centAmount",
        "currency",
        "className",
        "type",
        "size",
        'aria-label'
    ]);
    const { locale  } = useIntl();
    return /*#__PURE__*/ React.createElement("span", swcHelpers.extends({}, rest, {
        className: classnames('price', `price--${type}`, `price--${size}`, className)
    }), ariaLabel && /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, ariaLabel, "\xa0"), formatPrice({
        locale,
        value,
        currency,
        isCentAmount: !!centAmount
    }));
};
var Price$1 = Price;

export { Price$1 as default };
//# sourceMappingURL=Price.js.map
